<template>
  <v-row>
    <v-col cols="12">
      <template>
        <v-data-table
          :headers="myList.headers"
          :items="myList.items"
          :items-per-page="10"
          item-key="key"
          class="elevation-1"
          group-by="groupDate"
          disable-pagination
          hide-default-footer
          :search="search">
          <template v-slot:top>
            <v-card flat color="white" style="margin-bottom:6px;">
              <v-card-title>
                {{ selectedProfile.name }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6" lg="4">
                    <v-dialog
                      ref="dialogFilter"
                      v-model="modalFilter"
                      :return-value.sync="dates"
                      persistent
                      width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateFilterText"
                          label="Datum"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          clearable
                          @click:clear="dateFilterClear()"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="dates" range>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalFilter = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="dateFilterOk">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>                    
                  <v-col cols="12" md="6" lg="4" v-for="filter in fieldFilters" :key="filter.id">
                    <v-autocomplete
                      :items="filter.items"
                      item-text="name"
                      item-value="value"
                      v-model="filter.value"
                      :label="filter.name"
                      @change="setFieldFilter(filter.id, filter.value)"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" md="6" lg="4">
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Zoeken"
                      single-line
                      hide-details
                    ></v-text-field>                      
                  </v-col>
                </v-row>
              </v-card-text>

              <v-dialog v-model="dialog1" max-width="800px">
                <v-card>
                  <v-system-bar>
                    <span>Intrekken / Revoke</span>
                  </v-system-bar>
                  <v-card-text>
                    <v-row v-if="deletedItem">
                      <v-col cols="12">
                        <v-card>
                          <v-card-title>{{ deletedItem.profile.name }} / {{ deletedItem.profile.description }}</v-card-title>
                          <v-simple-table>
                            <template v-slot:default>
                              <tbody>
                                <tr v-if="deletedItem.organization">
                                  <td class="subtitle-2">Organisatie / Organization</td>
                                  <td>{{ deletedItem.organization.name }}</td>
                                </tr>
                                <tr>
                                  <td class="subtitle-2">Naam / Name</td>
                                  <td>{{ identityPerson(deletedItem).givenName + ' ' + (identityPerson(deletedItem).surnamePrefix ? ' ' + identityPerson(deletedItem).surnamePrefix : '') + ' ' + identityPerson(deletedItem).surname }}</td>
                                </tr>
                                <tr>
                                  <td class="subtitle-2">Startdatum / Start date</td>
                                  <td>{{ $moment.utc(deletedItem.startDate).local().format('dddd D MMM YYYY HH:mm') }}</td>
                                </tr>
                                <tr>
                                  <td class="subtitle-2">Status</td>
                                  <td>{{ statusIdToName(deletedItem.status, true) }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card>
                        <br />
                        <v-card color="#eeeeee">
                          <v-card-text>
                            <v-icon light large color="error" class="ma-2 float-left">warning</v-icon>
                            <div class="body-1">
                              Weet u zeker dat de {{ deletedItem.profile.name }} wilt annuleren?
                              <br />
                              Are you sure to cancel the {{ deletedItem.profile.description }} ?
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12">
                        <v-btn class="ma-2 float-right" @click="close">annuleer / cancel</v-btn>
                        <v-btn color="error" class="ma-2" @click="save">intrekken / revoke</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialog2" max-width="800px">
                <v-card>
                  <v-system-bar>
                    <span>Groep bewerken / Edit group</span>
                  </v-system-bar>
                  <v-card-text>
                    <v-row v-if="editedItem">
                      <v-col cols="12">
                        <v-card>
                          <v-card-title>{{ editedItem.profile.name }} / {{ editedItem.profile.description }}</v-card-title>
                          <v-simple-table>
                            <template v-slot:default>
                              <tbody>
                                <tr v-if="editedItem.organization">
                                  <td class="subtitle-2">Organisatie / Organization</td>
                                  <td>{{ editedItem.organization.name }}</td>
                                </tr>
                                <tr>
                                  <td class="subtitle-2">Naam / Name</td>
                                  <td>{{ identityPerson(editedItem).givenName + ' ' + (identityPerson(editedItem).surnamePrefix ? ' ' + identityPerson(editedItem).surnamePrefix : '') + ' ' + identityPerson(editedItem).surname }}</td>
                                </tr>
                                <tr>
                                  <td class="subtitle-2">Startdatum / Start date</td>
                                  <td>{{ $moment.utc(editedItem.startDate).local().format('dddd D MMM YYYY HH:mm') }}</td>
                                </tr>
                                <tr>
                                  <td class="subtitle-2">Status</td>
                                  <td>{{ statusIdToName(editedItem.status, true) }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card>
                        <br />
                        <v-card color="#eeeeee">
                          <v-card-text>
                            <v-icon light large color="primary" class="ma-2 float-left">group</v-icon>
                            <div class="body-1">
                              Deze afspraak maakt deel uit van een groep, maak een keuze
                              <br />
                              This appointment is part of a group, make a choice
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12">
                        <v-btn color="primary" class="ma-2 white--text" @click="editGroupIdentity(1, editedItem.id)">
                            bezoeker / visitor
                          <v-icon right dark>person</v-icon>
                        </v-btn>
                        <v-btn color="primary" class="ma-2 white--text" @click="editGroupIdentity(2, editedItem.id)">
                            afspraak groep / appointment group
                          <v-icon right dark>group</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <v-btn class="ma-2 float-right" @click="close">annuleer / cancel</v-btn>
                          <v-btn color="primary" class="ma-2 white--text" @click="editGroupIdentity(0, editedItem.id)">
                          verlaat groep / leave group
                          <v-icon right dark>group</v-icon>
                          <v-icon right dark>arrow_forward</v-icon>
                          <v-icon right dark>person</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialog3" max-width="800px">
                <v-card>
                  <v-system-bar>
                    <span>Overzicht / Details</span>
                  </v-system-bar>
                  <v-card-text>
                    <v-row v-if="showedItem">
                      <v-col cols="12">
                        <v-card>
                          <v-card-title>{{ showedItem.profile.name }} / {{ showedItem.profile.description }}</v-card-title>
                          <v-simple-table>
                            <template v-slot:default>
                              <tbody>
                                <tr v-if="showedItem.organization">
                                  <td class="subtitle-2">Organisatie / Organization</td>
                                  <td>{{ showedItem.organization.name }}</td>
                                </tr>
                                <tr>
                                  <td class="subtitle-2">Naam / Name</td>
                                  <td>{{ identityPerson(showedItem).givenName + ' ' + (identityPerson(showedItem).surnamePrefix ? ' ' + identityPerson(showedItem).surnamePrefix : '') + ' ' + identityPerson(showedItem).surname }}</td>
                                </tr>
                                <tr>
                                  <td class="subtitle-2">Startdatum / Start date</td>
                                  <td>{{ $moment.utc(showedItem.startDate).local().format('dddd D MMM YYYY HH:mm') }}</td>
                                </tr>
                                <tr>
                                  <td class="subtitle-2">Einddatum / End date</td>
                                  <td v-if="showedItem.endDate">{{ $moment.utc(showedItem.endDate).local().format('dddd D MMM YYYY HH:mm') }}</td>
                                </tr>
                                <tr>
                                  <td class="subtitle-2">Status</td>
                                  <td>{{ statusIdToName(showedItem.status, true) }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card>
                        <br />
                        <v-card v-for="item in showedItem.profile.steps" :key="item.id">
                          <v-card-title>{{ item.name }}</v-card-title>
                          <v-card-text>
                            <v-simple-table dense>
                              <template v-slot:default>
                                <tbody>
                                  <tr v-for="field in item.fields" :key="field.id">
                                    <template v-if="field.type == 3 || field.type == 21">
                                      <td width="50%">{{ field.name }}:</td>
                                      <td>{{ field.value ? $moment.utc(field.value).local().format("DD-MM-YYYY") : "" }}</td>
                                    </template>
                                    <template v-else-if="field.type == 20">
                                      <td width="50%">{{ field.name }}:</td>
                                      <td>{{ sexesIdToName(field.value, true) }}</td>
                                    </template>
                                    <template v-else-if="field.type == 38 && field.value != null">
                                      <td width="50%">{{ getDocumentTypeNameById(field.name) }}:</td>
                                      <td>{{ getDocumentDateById(field.name) }}</td>
                                    </template>
                                    <template v-else-if="field.type != 38">
                                      <td width="50%">{{ field.name }}:</td>
                                      <td>{{ showValue(field.value) }}</td>
                                    </template>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12">
                        <v-btn class="ma-2 float-right" @click="close">sluit / close</v-btn>
                        <v-btn color="error" class="ma-2" v-if="showRenew()"
                          @click="renew(showedItem.id)">vernieuw aanvraag / renew application</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
               
                  <v-list>
                    <v-list-group v-if="showedItem && showedItem.events">
                      <template v-slot:activator>
                        <v-list-item-title>Audit Trail</v-list-item-title>
                      </template>
                      <v-list-item>
                        <v-list-item-content>
                          <v-card>
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">Date/time</th>
                                    <th class="text-left">ModifiedBy</th>
                                    <th class="text-left">Action</th>
                                    <th class="text-left">Message</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="item in showedItem.events" :key="item.id">
                                    <td>{{ $moment.utc(item.created).format("DD-MM-YYYY HH:mm:ss") }}</td>
                                    <td>{{ (item.modifiedBy.surnamePrefix ? item.modifiedBy.surnamePrefix + " " : "") +  item.modifiedBy.surname }}</td>
                                    <td>{{ item.action }}</td>
                                    <td>{{ item.message }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-card>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                </v-card>
              </v-dialog>
            </v-card>
          </template>

          <template v-slot:group="{ items }">
            <tr @click="toggleGroup(items[0].datum)" v-if="identities && (!documentsExist && identities.length > minimalRows)">
              <td colspan="100%">
                <strong>{{ items[0].datum }}</strong>
              </td>
            </tr>
            <tr v-for="item in items" :key="item.key" v-show="!item.hide" :style="expirationColor(item)">
              <td v-for="header in myList.headers" :key="header.id">
                <div
                  v-if="header.value == 'action'"
                  style="min-width:80px;max-width:80px;text-align:right;"
                >
                  <v-icon
                    v-if="(me.person.isValidator && 
                      ((item.status == statusNameToId('Validation') && item.validation == 'todo')
                        || item.status == statusNameToId('Announced') 
                        || item.status == statusNameToId('Active')))"
                    small
                    class="mr-3"
                    @click="processIdentity(item)"
                    :color="validatorColor(item)"
                  >{{validatorIcon(item)}}</v-icon>
                  <v-icon v-else-if="(me.person.isEditor && item.status == statusNameToId('Validation') && item.validation == 'invalid')" 
                    small 
                    class="mr-3" 
                    @click="editIdentity(item)"
                    :color="validatorColor(item)"
                  >mdi-checkbox-marked</v-icon>
                  <v-icon v-else-if="item.status < statusNameToId('Revoked')" 
                    small 
                    class="mr-3" 
                    @click="showIdentity(item)"
                    :color="validatorColor(item)"
                  >mdi-eye</v-icon>
                  <v-icon
                    v-if="me.person.isEditor && ((item.status < statusNameToId('Active') && !documentsExist) || 
                      (item.status < statusNameToId('Validation') && documentsExist))"
                    small
                    class="mr-3"
                    @click="editIdentity(item)"
                  >edit</v-icon>
                  <v-icon v-else small class="mr-3" color="transparent">edit</v-icon>
                  <v-icon v-if="item.status < statusNameToId('Active')" small @click="deleteItem(item)">delete</v-icon>
                  <v-icon v-else small color="transparent">delete</v-icon>
                </div>
                <div
                  v-if="header.value == 'status'"
                  @click="if (me.person.isValidator && (item.status == statusNameToId('Announced') || item.status == statusNameToId('Active'))) processIdentity(item)"
                  style="cursor:pointer"
                >{{ statusIdToName(item[header.value], true) }}</div>
                <div
                  v-if="header.value != 'action' && header.value != 'status'"
                  @click="if (me.person.isValidator && (item.status == statusNameToId('Announced') || item.status == statusNameToId('Active'))) processIdentity(item)"
                  style="cursor:pointer"
                >{{ item[header.value] }}</div>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <p>No results</p>
          </template>
        </v-data-table>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["identities", "profiles", "me", "selectedProfile"],
  data: () => ({
    loading: true,
    organizations: [],
    organizationProfiles: [],
    dialog1: false,
    dialog2: false,
    dialog3: false,
    itemIndex: -1,
    showedItem: null,
    deletedItem: null,
    editedItem: null,
    search: "",
    fieldFilters: [],
    modalFilter: false,
    dates: [],
    tempitem: null,
    minimalRows: 30,
    documentsExist: false,
    documentTypes: [],
  }),
  computed: {
    dateFilterText:
      {
        get() {
          let datesString = "";
          if (this.dates.length > 0) {
            if (this.dates.length > 1) {
              if (this.dates[0] > this.dates[1]) {
                let tempDate = this.dates[0];
                // eslint-disable-next-line
                this.dates[0] = this.dates[1];
                // eslint-disable-next-line
                this.dates[1] = tempDate;
              }
            }
            datesString = this.$moment
              .utc(this.dates[0])
              .local()
              .format("DD-MM-YYYY");
            if (this.dates.length > 1) {
              datesString +=
                " ~ " +
                this.$moment
                  .utc(this.dates[1])
                  .local()
                  .format("DD-MM-YYYY");
            }
          }
          return datesString;
        },
        set() {
        }
    },
    myList() {
      return this.updateList();
    }
  },
  methods: {
    updateList() {
      var result = {
        headers: [{ text: "Datum/Tijd", value: "tijd", sortable: false, width: "150px" }],
        items: []
      };
      var newheader = true;
      var first = true;
      var firstdate = null;
      this.fieldFilters = [];
      this.documentsExist = false;
      if (this.identities && this.identities.length > 0 ) {
        var p = this.profiles.find(p => p.id == this.identities[0].profileId);
        this.identities.forEach(i => {
          // filter when no sets are available 
          if (i.sets[i.sets.length - 1] != null) {
            var rawStartDate = i.startDate;
            switch(p.sortType) {
              case 1:
                rawStartDate = i.endDate
                break;
              case 2:
                rawStartDate = i.created
                break;
              case 3:
                rawStartDate = i.modified
                break;
            }
            if (first) {
              first = false;
              firstdate = this.$moment
                .utc(rawStartDate)
                .local()
                .format("DD-MM-YYYY");
            }
            var item = {
              key: "",
              name: "",
              datum: "",
              tijd: "",
              status: 0,
              statusName: "",
              hide: false,
              groupDate: "",
              validation: "",
              validationDays: null
            };
            var tempvalues = [];
            var allowedFromFilter = true;
            p.steps.forEach(step => {
              step.fields.forEach(stepField => {
                if (stepField.type == 38) {
                  this.documentsExist = true;
                }
                if (stepField.showOnList) {
                  i.sets[i.sets.length - 1].fields.forEach(setField => {
                    if (setField.name == stepField.name) {
                      if (setField.type == 37) {
                        if (newheader) {
                          result.headers.push({
                            text: this.getOrganizationProfileName(setField.name),
                            value: this.getOrganizationProfileName(
                              setField.name
                            ).toLowerCase()
                          });
                        }
                        tempvalues[
                          this.getOrganizationProfileName(
                            setField.name
                          ).toLowerCase()
                        ] = this.getOrganizationName(setField.value);
                      } else {
                        if (newheader) {
                          result.headers.push({
                            text: setField.name,
                            value: setField.name.toLowerCase()
                          });
                        }
                        if (setField.type == 3 || setField.type == 21) {
                          if (setField.value != null && setField.value != '') {
                            tempvalues[setField.name.toLowerCase()] = 
                            this.$moment
                              .utc(setField.value)
                              .local()
                              .format("DD-MM-YYYY")
                            } else {
                              tempvalues[setField.name.toLowerCase()] = '-';
                            }
                        } else {
                          tempvalues[setField.name.toLowerCase()] =
                            setField.value;
                        }
                      }
                    }
                  });
                } else if (stepField.filterOnList) {
                  var current = this.getFieldFilter(stepField.id);
                  if (current) {
                    i.sets[i.sets.length - 1].fields.forEach(setField => {
                      if (setField.name == stepField.name) {
                        if (setField.value != current) allowedFromFilter = false;
                      }
                    });
                  }
                  if (current) stepField.value = current;
                  if (newheader) this.fieldFilters.push(stepField);
                }
              });
            });
            newheader = false;
            item.key = i.id;
            item.datum = this.$moment
              .utc(rawStartDate)
              .local()
              .format("DD-MM-YYYY");
            item.tijd = this.$moment
              .utc(rawStartDate)
              .local()
              .format("HH:mm");
            item.groupDate = this.$moment
              .utc(rawStartDate)
              .local()
              .format("YYYY-MM-DD");
            if (this.identities && (!this.documentsExist && this.identities.length > this.minimalRows)) {
              item.hide = item.datum != firstdate;
            }
            else {
              item.tijd = item.datum + " " + item.tijd;
            }
            item.status = i.status;
            item.statusName = this.statusIdToName(i.status, true);
            if (this.documentsExist){
              item.tijd = item.datum;
              item.validation = "todo";
              if (i.events) {
                var validation = i.events.find(e => e.action == 'Validation');
                if (validation != null) {
                  if (validation.message.indexOf('invalid') !== -1)
                    item.validation = "invalid";
                  else
                    item.validation = "valid";
                }
              }
              if (i.endDate) {
                item.validationDays = this.$moment.utc(i.endDate).local().diff(this.$moment(), 'days');
              }
            }
            if (i.groupProfileId) item.tijd += ' (G)';
            if (allowedFromFilter) {
              result.items.push({ ...item, ...tempvalues });
            }
          } 
        });
        result.headers.push(
          { text: "Status", value: "statusName", sortable: false },
          { text: "Actions", value: "action", sortable: false }
        );
      } else if (this.profiles && this.profiles.length > 0) {
        var myProfile = this.profiles[0];
        if (this.selectedProfile != null) {
          myProfile = this.selectedProfile;
        }
         myProfile.steps.forEach(step => {
          step.fields.forEach(stepField => {
            if (stepField.type == 38) {
              this.documentsExist = true;
            }
            if (stepField.showOnList) {
              result.headers.push({
                text: stepField.name,
                value: stepField.name.toLowerCase()
              });
            } else if (stepField.filterOnList) {
              this.fieldFilters.push(stepField);
            }
          });
        });
        result.headers.push(
          { text: "Status", value: "status", sortable: false },
          { text: "Actions", value: "action", sortable: false }
        );
      }
      this.loading = false;
      return result;
    },
    dateFilterOk() {
      this.$refs.dialogFilter.save(this.dates);
      this.$emit("dates", this.dates);
    },
    dateFilterClear() {
      this.dates = [];
      this.$refs.dialogFilter.save(this.dates);
      this.$emit("dates", this.dates);
    },
    setFieldFilter(id, value) {
      if (id && value) {
        localStorage.setItem("filter." + id + "." + this.selectedProfile.id, JSON.stringify(value));
        this.loading = true;
      } else {
        this.deleteFieldFilters();
      }      
      this.updateList();
    },
    deleteFieldFilters() {
      var arr = [];
      for (var i1 = 0; i1 < localStorage.length; i1++){
          if (localStorage.key(i1).substring(0,7) == 'filter.') {
              arr.push(localStorage.key(i1));
          }
      }
      for (var i2 = 0; i2 < arr.length; i2++) {
          localStorage.removeItem(arr[i2]);
      }
    },
    getFieldFilter(id) {
      if (localStorage.getItem("filter." + id + "." + this.selectedProfile.id))
      try {
        return JSON.parse(localStorage.getItem("filter." + id + "." + this.selectedProfile.id));
      } catch(e) {
          this.deleteFieldFilters();
      }      
    },
    toggleGroup(datum) {
      this.myList.items.forEach(item => {
        if (item.datum === datum) {
          item.hide = !item.hide;
        } else item.hide = true;
      });
    },
    showValue(val) {
      if (val == "true") return "Ja / Yes";
      else if (val == "false") return "Nee / No";
      else return val;
    },
    getDocumentTypes() {
      if (this.documentsExist == true) {
        this.$http
          .get("api/documenttypes/")
          .then(request => {
            if (request.status == 200) {
              this.documentTypes = request.data;
            }
          })
          .catch(e => {
            this.$root.$children[0].$emit("display-error", "1300", e);
          });
      }
    },
    sexesIdToName(id, nl) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getSexesName(id, nl);
      }
      else return "";
    },
    getDocumentTypeNameById(id) {
      if (this.documentsExist && this.documentTypes.length > 0) {
        return this.documentTypes.find(x => x.id == id).name;
      }
      return '';
    },
    getDocumentDateById(id) {
      if (this.documentsExist) {
        if (this.showedItem && this.showedItem.person && this.showedItem.person.documents) {
          var doc = this.showedItem.person.documents.find(x => x.type.id == id);
          if (doc != null && doc.expirationDate) {
          var date = this.showedItem.person.documents.find(x => x.type.id == id).expirationDate;
          if (date != null)
            return this.$moment.utc(date).local().format("DD-MM-YYYY");
          }
        }
      }
      return '';
    },
    getOrganizationProfileName(id) {
      return this.organizationProfiles.find(x => x.id == id).name;
    },
    getOrganizationName(id) {
      return this.organizations.find(x => x.id == id).name;
    },
    getOrganizations() {
      this.$http
        .get("api/organizations/")
        .then(request => {
          this.organizations = request.data;
        })
        .catch((e) => {
          this.$root.$children[0].$emit("display-error", "1301", e);
        });
    },
    getOrganizationProfiles() {
      this.$http
        .get("api/organizationprofiles/")
        .then(request => {
          this.organizationProfiles = request.data;
        })
        .catch((e) => {
          this.$root.$children[0].$emit("display-error", "1302", e);
        });
    },
    deleteItem(item) {
      let deletedItem = this.combineProfileSetsAndAssets(
        Object.assign({}, this.identities.find(x => x.id == item.key))
      );
      this.deletedItem = deletedItem;
      this.dialog1 = true;
    },
    combineProfileSetsAndAssets(item) {
      var p = this.profiles.find(p => p.id == item.profileId)
      if (p) {
        item.profile = JSON.parse(JSON.stringify(p));
        if (item.profile.steps) {
          item.profile.steps.forEach(s => {
            if (s.fields) {
            s.fields.forEach(f => {
              if (item.sets && item.sets.length > 0 && item.sets[0] != null) {
                var matchingField = item.sets[0].fields.find(y => y.name == f.name);
                  if (matchingField) {
                    f.value = matchingField.value;
                  }
                }
              })
            }
          })
        }
        if (item.assets && item.profile.assetProfiles) {
          item.profile.assetProfiles.forEach(a => {
            var matchingAsset = item.assets.find(x => x.profileId == a.id);
            if (matchingAsset && matchingAsset.fields) {
              a.fields.forEach(f => {
                var matchingField = matchingAsset.fields.find(
                y => y.name == f.name
              );
              if (matchingField) {
                f.value = matchingField.value;
              }
            });
            }
          });
        }
      }
      return item;
    },
    showIdentity(item) {
       this.$http
        .get("api/identities/" + item.key)
        .then(request => {
          this.tempitem = request.data;
          this.showedItem = this.tempitem = this.combineProfileSetsAndAssets(Object.assign({}, this.tempitem));
          this.dialog3 = true;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1303", e);
        });
    },
    editIdentity(item) {
      let editedItem = this.combineProfileSetsAndAssets(
        Object.assign({}, this.identities.find(x => x.id == item.key))
      );
      if (editedItem.groupProfileId) {
        this.editedItem = editedItem;
        this.dialog2 = true;
      } else {
        this.editGroupIdentity(0, editedItem.id)
      }
    },
    editGroupIdentity(choice, id) {
      this.$http
        .get("api/identities/" + id)
        .then(request => {
          this.tempitem = request.data;
          this.$parent.groupEditChoice = choice;
          this.$parent.selectedIdentity = this.combineProfileSetsAndAssets(Object.assign({}, this.tempitem))
          if (choice == 0)
           this.$parent.selectedIdentity.groupProfileId = null;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1304", e);
        });
    },
    processIdentity(item) {
     this.$http
        .get("api/identities/" + item.key)
        .then(request => {
          this.tempitem = request.data;
          if (this.documentsExist && item.status == this.statusNameToId("Validation"))
            this.$parent.validateIdentity = this.combineProfileSetsAndAssets(Object.assign({}, this.tempitem))
          else
            this.$parent.detailIdentity = this.combineProfileSetsAndAssets(Object.assign({}, this.tempitem))
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1307", e);
        });
    },
    save() {
      if (this.deletedItem != null) {
        this.$parent.loading = true;
        this.deletedItem.status = this.statusNameToId('Revoked');
        let indentityView = { identity: this.deletedItem, note: "force" };
        this.$http
          .post("api/identities/", indentityView)
          .then(request => {
            if (request.status == 201) {
              this.$emit("done");
            } else
            this.$parent.loading = false;
          })
          .catch(e => {
            this.$root.$children[0].$emit("display-error", "1305", e);
            this.$parent.loading = false;
          });
      }
      this.close();
    },
    close() {
      this.dialog1 = false;
      this.dialog2 = false;
      this.dialog3 = false;
      setTimeout(() => {
        this.deletedItem = null;
        this.editedItem = null;
        this.showedItem = null;
      }, 300);
    },
    showRenew() {
      if (this.documentsExist && this.showedItem) {
        if (this.showedItem.events) {
          var event = this.showedItem.events.find(e => e.action == "Renewed" && e.modified == this.showedItem.modified);
          if (event)
            return false;
        }
        if (this.showedItem.status == this.statusNameToId('Active') &&
          this.$moment.utc(this.showedItem.endDate).local().diff(this.$moment(), 'days') < 60)
          return true;
      }
      return false;
    },
    renew(id) {
      this.$http
        .get("api/identities/renew/" + id)
        .then(request => {
          if (request.status == 200) {
            this.$emit("done");
          } else
            this.$parent.loading = false;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1306", e);
          this.$parent.loading = false;
        });
      this.close();
    },
    statusNameToId(name) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getIdentityStatusId(name);
      }
      else return "";
    },
    statusIdToName(id, nl) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getIdentityStatusName(id, nl);
      }
      else return "";
    },
    validatorIcon(item) {
      if ((item.validation == '' || item.validation == 'valid') || 
      item.status ==  this.statusNameToId('Active')) return "style";
        else return "mdi-checkbox-marked";
    },
    validatorColor(item) {
      if ((this.documentsExist) 
        && (item.validation == 'valid' || item.status ==  this.statusNameToId('Active'))) return "success";
        else if (item.validation == 'invalid') return "error";
        else if (item.validation == 'todo') return "warning";
        else return "";
    },
    expirationColor(item) {
      if (this.documentsExist && item && item.status ==  this.statusNameToId('Active')) {
        if (item.validationDays < 30)
          return { color: '#ff5252' };
        else if (item.validationDays < 60)
          return { color: '#fb8c00' };
        else
          return {};
      }
      return {};
    },
    identityPerson(ident) {
      let person = { givenName:"", surnamePrefix:"", surname:"" };
      if (ident.sets && ident.sets[0].fields) {
        ident.sets[0].fields.forEach(f => {
          if (f.type == 10)
            person.givenName = f.value;
          else if (f.type == 13)
            person.surnamePrefix = f.value;
          else if (f.type == 14)
            person.surname = f.value;
        })
      }
      return person;
    }
  },
  mounted() {
    this.getOrganizations();
    this.getOrganizationProfiles();
    this.updateList();
    this.getDocumentTypes();
  }
};
</script>